import { classNames } from "primereact/utils"
import type { FC } from "react"

const StepProgress: FC<Props> = ({ currentStep, totalSteps, className }) => {
  const percent = Math.round((currentStep / totalSteps) * 100)

  return (
    <div className={classNames("w-full", className)}>
      <div className="flex justify-between  mb-4">
        <span className="font-semibold text-gray-900 text-sm leading-6">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-gray-500 leading-5 text-sm">{percent}%</span>
      </div>
      <div className="h-3 w-full rounded-full bg-gray-200 overflow-hidden">
        <div
          className="h-full rounded-full bg-secondary transition-all duration-300"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  )
}

type Props = {
  currentStep: number
  totalSteps: number
  className?: string
}

export { StepProgress }
